import Client from 'common/api/Client'
import config from 'src/config'
import { getRefreshToken, setAccessToken } from 'common/auth/token'

class AuthClient extends Client {
  constructor () {
    super({ apiPath: config.api.auth })
  }

  refreshAccessToken () {
    const refreshToken = getRefreshToken()
    const url = 'token_refresh'
    const body = { refresh_token: refreshToken }
    return this.post(url, { body }).then(data => {
      setAccessToken(data.access_token)
    })
  }
}

export default new AuthClient()
